// extracted by mini-css-extract-plugin
module.exports = {"blade-I":"Other_blade-I__6s8iv"};